import { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useScheduleEventStore } from "../hooks";
import { BsHouseDoor } from "../../assets/icons/vander";
import { TopHeader } from "../components/utils";
import { PatientInfoCard, PatientSurgeryInfocard } from "../components/cards";
import { DoctorLayout } from "../layout";

const Nav = () => {
  return (
    <nav aria-label="breadcrumb" className="d-inline-block">
      <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
        <li className="breadcrumb-item" aria-current="page">
          <Link to="/doctor/main">
            <BsHouseDoor className="icons-sm" /> Pacientes
          </Link>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Perfil
        </li>
      </ul>
    </nav>
  );
};

export const PatientProfilePage = () => {
  const navigate = useNavigate();

  const {
    // Props
    scheduleEvent,

    // Methods
    handleClearScheduleEvent,
  } = useScheduleEventStore();

  const scheduleEventRef = useRef(scheduleEvent);

  useEffect(() => {
    return () => {
      if (!scheduleEventRef.current) return;
      handleClearScheduleEvent(scheduleEventRef.current);
    };
  }, []);

  useEffect(() => {
    scheduleEventRef.current = scheduleEvent;
  }, [scheduleEvent]);

  useEffect(() => {
    if (!scheduleEvent) {
      navigate("/doctor/main");
    }
  }, [scheduleEvent, navigate]);

  if (!scheduleEvent) return null;

  return (
    <DoctorLayout>
      <TopHeader Nav={Nav} />

      <div className="vstack gap-4 mt-2">
        <h1 className="mb-0">Información del paciente</h1>
        <PatientInfoCard />
        <PatientSurgeryInfocard />
      </div>
    </DoctorLayout>
  );
};
